module.exports = __webpack_public_path__ + "img/bgVote.1af0f918.png";